import SimpleTour from "./simpleTour";

export default SimpleTour;
